import { Component, Input, OnInit } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import * as moment from 'moment';
import { Color, Label } from 'ng2-charts';
import { SleepService } from 'src/app/services/sleep.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-m3-sleep-chart',
  templateUrl: './m3-sleep-chart.component.html',
  styleUrls: ['./m3-sleep-chart.component.scss'],
})
export class M3SleepChartComponent implements OnInit {
  @Input() allSleeps;
  @Input() nextAppointment;
  @Input() age;

  // Line chart
  public barChartOptions: ChartOptions = {
    responsive: true,
    scales: {
      yAxes: [
        {
          id: 'y-axis-1',
          type: 'linear',
          display: true,
          position: 'left',
          ticks: {
            beginAtZero: true,
            fontFamily: environment.chartDefaults.fontFamily,
            fontSize: environment.chartDefaults.fontSize,
            fontColor: environment.chartDefaults.fontColor,
            fontStyle: environment.chartDefaults.fontStyle,
          },
          gridLines: {
            display: true,
            lineWidth: 1,
            color: '#dddddd',
          },
          scaleLabel:{
            labelString:'Average daily sleep (hrs/day)',
            display:true,
            fontFamily: environment.chartDefaults.fontFamily,
            fontSize: environment.chartDefaults.fontSize,
            fontColor: environment.chartDefaults.fontColor,
            fontStyle: environment.chartDefaults.fontStyle,
          }
        },
      ],
      xAxes: [
        {
          gridLines: {
            display: false,
            lineWidth: 1,
            color: '#dddddd',
          },
         
          ticks: {
            fontFamily: environment.chartDefaults.fontFamily,
            fontSize: environment.chartDefaults.fontSize,
            fontColor: environment.chartDefaults.fontColor,
            fontStyle: environment.chartDefaults.fontStyle,
          },
          scaleLabel:{
            labelString:'Week commencing',
            display:true,
            fontFamily: environment.chartDefaults.fontFamily,
            fontSize: environment.chartDefaults.fontSize,
            fontColor: environment.chartDefaults.fontColor,
            fontStyle: environment.chartDefaults.fontStyle,
          }
        },
      ],
    },
    legend: {
      display: false,
    },
    plugins: {
      datalabels: {
        
      },
    },
  };
  public barChartLabels: Label[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;

  public pointBackgroundColors = [];
  public pointBorderColors = [];
  public backgroundColors = [];
  public barChartData: ChartDataSets[] = [
    {
      data: [],
      label: 'Sleep hours',
      borderColor: '#22B4FC',
      fill: true,
      backgroundColor: this.backgroundColors,
    },
  ];
  public barChartColors: Color[] = [
    { backgroundColor: environment.primaryColor }
  ];

  // end chart

  constructor(private sleepService:SleepService) {}

  ngOnInit(): void {
    if (this.nextAppointment) {
      this.barChartOptions.scales.xAxes[0].ticks.max =
        this.nextAppointment.appointment_date;
    }

    this.setChartData();
  }

  setChartData() {
    this.barChartData[0].data = [];

    //do weekly sleeps!

    let weeklySleeps = this.sleepService.getWeeklyAverages(this.allSleeps.slice().reverse());
    // setup chart data

    for (var key in weeklySleeps) {
      if (weeklySleeps.hasOwnProperty(key)) {

      this.barChartLabels.push(
        moment(key).format('DD-MM-YY')
      );
      this.barChartData[0].data.push(Math.round(weeklySleeps[key]/60*10)/10);
      this.pointBackgroundColors.push(environment.ragColors[this.getRagForAge(weeklySleeps[key], this.age)]);
      this.pointBorderColors.push(environment.ragColors[this.getRagForAge(weeklySleeps[key], this.age)]);
      this.backgroundColors.push(environment.ragColors[this.getRagForAge(weeklySleeps[key], this.age)]);
      }
    };


    /*
    this.allSleeps.forEach((value, key) => {
      this.barChartLabels.push(
        moment(value.date_recorded).format('YYYY-MM-DD')
      );
      this.barChartData[0].data.push(value.sleep/60);
      this.pointBackgroundColors.push(environment.ragColors[this.getRagForAge(value.sleep, this.age)]);
      this.pointBorderColors.push(environment.ragColors[this.getRagForAge(value.sleep, this.age)]);


    });*/
  }


  getRagForAge(sleep: any, age: number) {
    return this.sleepService.getRagForAge(sleep, age);
  }
}


